export default function loadWowHead() {
  const existingScript = window.$WowheadPower;
  const options = {
    colorLinks: true,
    iconizeLinks: true,
    renameLinks: true,
    iconSize: true
  };

  if (!existingScript) {
    const optionsScript = document.createElement('script');
    optionsScript.text = `
      window.wowhead_tooltips = ${JSON.stringify(options)};
    `;
    document.body.appendChild(optionsScript);

    const script = document.createElement('script');
    script.src = 'https://wow.zamimg.com/widgets/power.js';
    document.body.appendChild(script);
  }
};



// WEBPACK FOOTER //
// ./components/html/thirdParty/WowHead/loadWowHead.js